import { render, staticRenderFns } from "./YagiChatBotSystemBubble.vue?vue&type=template&id=2f4472ae&scoped=true"
import script from "./YagiChatBotSystemBubble.vue?vue&type=script&setup=true&lang=ts"
export * from "./YagiChatBotSystemBubble.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./YagiChatBotSystemBubble.vue?vue&type=style&index=0&id=2f4472ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4472ae",
  null
  
)

export default component.exports